import { ColumnConfigDialogComponent } from './system/models/ColumnConfigDialog/ColumnConfigDialog.component';
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './system/general/logins/login/login.component';
import { Login2Component } from './system/general/logins/login2/login2.component';
import { HomeComponent } from './system/general/menu/home.component';
import { DeviceComponent } from './system/repairman/device/device.component';
import { UserGroupsComponent } from './system/user/user-groups/user-groups.component';
import { UserListComponent } from './system/user/user-list/user-list.component';
import { ModelListComponent } from './system/repairman/model/model-list/model-list.component';
import { RstatusListComponent } from './system/repairman/rstatus/rstatus-list/rstatus-list.component';
import { ReceptionListComponent } from './system/repairman/reception/reception-list/reception-list.component';
import { UserSexComponent } from './system/user/user-sex/user-sex.component';
import { BelongListComponent } from './system/repairman/belong/belong-list/belong-list.component';
import { ObjectionsListComponent } from './system/repairman/objections/objections-list/objections-list.component';
import { RepairmanShelfStatusComponent } from './system/repairman/repairman-shelf-status/repairman-shelf-status.component';
import { ShelfListComponent } from './system/repairman/repairman-shelf/shelf-list/shelf-list.component';
import { PaymentTypeComponent } from './system/finance/payment-type/payment-type.component';
import { BankComponent } from './system/finance/bank/bank-list/bank.component';
import { ChequeStatusComponent } from './system/finance/cheque-status/cheque-status.component';
import { DocumentComponent } from './system/finance/document/document.component';
import { Financial2ListComponent } from './system/finance/financial2/financial2-list/financial2-list.component';
import { ServicesComponent } from './system/repairman/services/services.component';
import { WharehouseInvoiceTypeComponent } from './system/wharehouse/wharehouse-invoice-type/wharehouse-invoice-type.component';
import { WharehouseCostCenterComponent } from './system/wharehouse/wharehouse-cost-center/wharehouse-cost-center.component';
import { MaterialListComponent } from './system/wharehouse/wharehouse-material/material-list/material-list.component';
import { CurrencyComponent } from './system/finance/currency/currency.component';
import { CardexListComponent } from './system/wharehouse/wharehouse-cardex/cardex-list/cardex-list.component';
import { ProfitListComponent } from './system/finance/finance-profit/profit-list/profit-list.component';
import { UserServiceListComponent } from './system/user/user-service-list/user-service-list.component';
import { FinanceCardexComponent } from './system/finance/finance-cardex/finance-cardex.component';
import { WharehousePlaceComponent } from './system/wharehouse/wharehouse-place/wharehouse-place.component';
import { WharehouseGroupComponent } from './system/wharehouse/wharehouse-group/wharehouse-group.component';
import { Profit2ListComponent } from './system/finance/finance-profit2/profit2-list/profit2-list.component';
import { BascketListComponent } from './system/finance/bascket-list/bascket-list.component';
import { IncomeTypeComponent } from './system/finance/income-type/income-type.component';
import { DeviceStatusComponent } from './system/repairman/device-status/device-status.component';
import { CodeListComponent } from './system/service/code-list/code-list.component';
import { UserLogComponent } from './system/user/user-log/user-log.component';
import { MyReceiptComponent } from './system/repairman/my-receipt/my-receipt.component';
import { CostTypeGroupComponent } from './system/finance/cost-type-group/cost-type-group.component';
import { FinanceCardexPersonnelComponent } from './system/finance/finance-cardex-personnel/finance-cardex-personnel/finance-cardex-personnel.component';
import { UserStateComponent } from './system/user/user-state/user-state.component';
import { GuilsListComponent } from './system/user/guils/guils-list/guils-list.component';
import { BrandListComponent } from './system/repairman/brand/brand-list/brand-list.component';
import { CashListComponent } from './system/finance/cash/cash-list/cash-list.component';
import { FinanceBankListComponent } from './system/finance/finance-bank/finance-bank-list/finance-bank-list.component';
import { UserListAccessComponent } from './system/user/user-list-access/user-list-access.component';
import { UserListAccountsComponent } from './system/user/user-list-accounts/user-list-accounts.component';
import { ChequeListComponent } from './system/finance/cheque/cheque-list/cheque-list.component';
import { FinanceTaxComponent } from './system/finance/finance-tax/finance-tax.component';
import { CostListComponent } from './system/finance/finance-cost/cost-list/cost-list.component';
import { InvoiceSaleListComponent } from './system/wharehouse-invoice-sale/invoice-sale-list/invoice-sale-list.component';
import { BalanceListComponent } from './system/finance/balance/balance-list/balance-list.component';
import { IncomeListComponent } from './system/finance/finance-income/income-list/income-list.component';
import { BankToCashListComponent } from './system/finance/finance-bank-to-cash/bank-to-cash-list/bank-to-cash-list.component';
import { CashToBankListComponent } from './system/finance/finance-cash-to-bank/cash-to-bank-list/cash-to-bank-list.component';
import { RecieveListComponent } from './system/finance/finance-recieve/recieve-list/recieve-list.component';
import { PayListComponent } from './system/finance/finance-pay/pay-list/pay-list.component';
import { RepairmanInvoiceListComponent } from './system/repairman/repairman-invoice/repairman-invoice-list/repairman-invoice-list.component';
import { OrderCostsListComponent } from './system/wharehouse/wharehouse-order-costs/order-costs-list/order-costs-list.component';
import { WeightListComponent } from './system/wharehouse/wharehouse-weight/weight-list/weight-list.component';
// import { InvoiceBuyListComponent } from './system/wharehouse/wharehouse-invoice-buy/invoice-buy-list/invoice-buy-list.component';
import { InvoiceBuyListComponent } from './system/wharehouse-invoice-buy/invoice-buy-list/invoice-buy-list.component';
import { ProfitReportListComponent } from './system/finance/finance-profit-report/profit-report-list/profit-report-list.component';
import { UserVisitorListComponent } from './system/user/user-visitor/user-visitor-list/user-visitor-list.component';


const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "login2/:userToken/:userId", component: Login2Component },
  { path: "receipt/:id/:token", component: MyReceiptComponent },
  {
    path: "home", component: HomeComponent, children: [
      { path: "user-title/:id", component: UserSexComponent },
      { path: "device/:id", component: DeviceComponent },
      { path: "group/:id", component: WharehouseGroupComponent },
      { path: "groups/:id", component: UserGroupsComponent },
      { path: "user/:id", component: UserListComponent },
      { path: "user-account/:id", component: UserListAccountsComponent },
      { path: "brand/:id", component: BrandListComponent },
      { path: "model/:id", component: ModelListComponent },
      { path: "status/:id", component: RstatusListComponent },
      { path: "reception/:id/:status/:repairman/:pos", component: ReceptionListComponent },
      { path: "reception/:id/:status", component: ReceptionListComponent },
      { path: "reception/:id", component: ReceptionListComponent },
      { path: "reception-report/:id", component: ReceptionListComponent },
      { path: "belong/:id", component: BelongListComponent },
      { path: "objections/:id", component: ObjectionsListComponent },
      { path: "shelf-status/:id", component: RepairmanShelfStatusComponent },
      { path: "shelf/:id", component: ShelfListComponent },


      { path: "payment-type/:id", component: PaymentTypeComponent },
      { path: "bank/:id", component: BankComponent },
      { path: "cheque/:id", component: ChequeListComponent },
      { path: "cheque-status/:id", component: ChequeStatusComponent },
      { path: "document/:id", component: DocumentComponent },
      { path: "financial/:id/:document", component: Financial2ListComponent },
      { path: "financial2/:id", component: Financial2ListComponent },
      { path: "financial2-bank/:id", component: FinanceBankListComponent },
      { path: "cash/:id", component: CashListComponent },
      { path: "services/:id", component: ServicesComponent },

      { path: "invoice-type/:id", component: WharehouseInvoiceTypeComponent },
      { path: "cost-center/:id", component: WharehouseCostCenterComponent },
      { path: "material/:id", component: MaterialListComponent },
      { path: "currency/:id", component: CurrencyComponent },
      { path: "cardex/:id", component: CardexListComponent },
      { path: "profit/:id", component: ProfitListComponent },
      { path: "service/:id", component: UserServiceListComponent },
      { path: "access/:id", component: UserListAccessComponent },
      { path: "cost-type/:id", component: CostTypeGroupComponent },
      { path: "finance-cardex/:id", component: FinanceCardexComponent },
      { path: "charge/:id", component: BascketListComponent },
      { path: "place/:id", component: WharehousePlaceComponent },
      { path: "profit2/:id", component: Profit2ListComponent },
      { path: "income-type/:id", component: IncomeTypeComponent },
      { path: "device-status/:id", component: DeviceStatusComponent },
      { path: "code/:id", component: CodeListComponent },
      { path: "log/:id", component: UserLogComponent },
      { path: "cardex-personnel/:id", component: FinanceCardexPersonnelComponent },
      { path: "state/:id", component: UserStateComponent },
      { path: "guilds/:id", component: GuilsListComponent },
      { path: "tax/:id", component: FinanceTaxComponent },
      { path: "cost/:id", component: CostListComponent },
      { path: "buy/:id", component: InvoiceBuyListComponent },
      { path: "sale/:id", component: InvoiceSaleListComponent },
      { path: "balance/:id", component: BalanceListComponent },
      { path: "income/:id", component: IncomeListComponent },
      { path: "bank-to-cash/:id", component: BankToCashListComponent },
      { path: "cash-to-bank/:id", component: CashToBankListComponent },
      { path: "recieve/:id", component: RecieveListComponent },
      { path: "pay/:id", component: PayListComponent },
      { path: "repairman-invoice/:id", component: RepairmanInvoiceListComponent },
      { path: "orders-costs/:id", component: OrderCostsListComponent },
      { path: "weight/:id", component: WeightListComponent },
      { path: "profit-report/:id", component: ProfitReportListComponent },
      { path: "visitor/:id", component: UserVisitorListComponent },
    ]
  },
  { path: "login", component: LoginComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class appRoutingModule {

}
